// extracted by mini-css-extract-plugin
export default {"summary":"Summary_summary__tORO4","summary-appear":"Summary_summary-appear__i-LXz","scale":"Summary_scale__UKlkY","fade-in":"Summary_fade-in__uGpfW"};